module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Medium.1dfa0cf4.ttf";